"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clear = exports.removeFailed = exports.removeSuccess = exports.removeRequest = exports.toggleSelect = exports.fetchFailed = exports.fetchSuccess = exports.fetchRequest = exports.setUserSearchString = exports.selectProject = void 0;
const ActionTypes = require("../../actionTypes/management/projectUsers");
const selectProject = (project) => ({
    type: ActionTypes.SELECT_PROJECT,
    payload: project
});
exports.selectProject = selectProject;
const setUserSearchString = (searhString) => ({
    type: ActionTypes.SET_USER_SEARCHING_STRING,
    payload: searhString
});
exports.setUserSearchString = setUserSearchString;
const fetchRequest = (customer, project, user) => ({
    type: ActionTypes.FETCH_REQUEST,
    payload: { customer, project, user }
});
exports.fetchRequest = fetchRequest;
const fetchSuccess = (payload) => ({
    type: ActionTypes.FETCH_SUCCESS,
    payload
});
exports.fetchSuccess = fetchSuccess;
const fetchFailed = (error) => ({
    type: ActionTypes.FETCH_FAILED,
    payload: error
});
exports.fetchFailed = fetchFailed;
const toggleSelect = (items, status) => ({
    type: ActionTypes.TOGGLE_SELECT,
    payload: {
        items,
        status
    }
});
exports.toggleSelect = toggleSelect;
const removeRequest = (payload) => ({
    type: ActionTypes.REMOVE_REQUEST,
    payload
});
exports.removeRequest = removeRequest;
const removeSuccess = () => ({
    type: ActionTypes.REMOVE_SUCCESS
});
exports.removeSuccess = removeSuccess;
const removeFailed = (error) => ({
    type: ActionTypes.REMOVE_FAILED,
    payload: error
});
exports.removeFailed = removeFailed;
const clear = () => ({
    type: ActionTypes.CLEAR
});
exports.clear = clear;
//# sourceMappingURL=projectUsers.js.map